<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>
<div class="demo-container" *ngIf="!isSpinner">
  <nz-card class="card-body">
    <div class="demo-wrapper">
      <img class="logo" src="/assets/logo/medexam.png" alt="medexam" />
      <h1>{{'demoTitle' | translate}}</h1>
      <p class="demo-intro">{{'demoIntro' | translate}}</p>

      <div class="error-message" *ngIf="loadError">
        {{'demoUnavailable' | translate}}
      </div>

      <ng-container *ngIf="!isCompleted">
        <button
          *ngIf="!hasSession"
          class="demo-primary-button"
          nz-button
          nzType="primary"
          nzBlock
          (click)="startDemo()"
        >
          {{'demoStart' | translate}}
        </button>
        <button
          *ngIf="hasSession"
          class="demo-primary-button"
          nz-button
          nzType="primary"
          nzBlock
          (click)="continueDemo()"
        >
          {{'demoContinue' | translate}}
        </button>
      </ng-container>

      <ng-container *ngIf="isCompleted">
        <p class="demo-completed">{{'demoAlreadyCompleted' | translate}}</p>
        <button
          class="demo-primary-button"
          nz-button
          nzType="primary"
          nzBlock
          (click)="goToResults()"
        >
          {{'demoSeeResults' | translate}}
        </button>
        <a
          class="demo-primary-button purchase-button"
          nz-button
          nzType="primary"
          nzBlock
          [href]="purchaseUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{'demoPurchaseCta' | translate}}
        </a>
      </ng-container>

      <div class="demo-secondary-links">
        <a routerLink="/login">{{'demoLoginLink' | translate}}</a>
      </div>
    </div>
  </nz-card>
</div>
